import { FormikValues } from 'formik';
import React, { FC } from 'react';
import styled from 'styled-components';
import { fadeIn } from '../../../../constants/keyframes/fades';
import { formatCurrency } from '../../../../helpers/formatting/formatting';
import IExpressService from '../../../../interfaces/sendReceipt/expressServices';
import FormikFieldWrapper from '../../../base/forms/formikFieldWrapper';
import FormikRadioTile from '../../../base/forms/formikRadioTile/formikRadioTile';
import FormikRadioTileLoader from '../../../base/misc/formikRadioTileLoader';
import { getIconByServiceCode } from './helpers';

interface Props {
	services: IExpressService[];
	loading: boolean;
	values: FormikValues;
	setFieldTouched: any;
	setFieldValue: any;
	errors: any;
}

const StyledService = styled.div`
	display: block;
	width: 100%;
	margin-bottom: 2rem;
	animation: ${fadeIn} 400ms linear;
`;

const StyledDescription = styled.div`
	margin-bottom: 3rem;
`;

const Services: FC<Props> = ({ setFieldValue, services, loading, values }) => {
	return (
		<div>
			{loading && [...Array(3)].map((_key, index) => <FormikRadioTileLoader key={index} />)}
			<FormikFieldWrapper name="deliveryService" languageComponent="sendReceipt">
				{services &&
					services.map((service, index) => (
						<div key={index}>
							<StyledService>
								<FormikRadioTile
									id={service.serviceCode}
									name="deliveryService"
									icon={getIconByServiceCode(service.serviceCode)}
									setFieldValue={setFieldValue}
									label={service.serviceHeader}
									price={formatCurrency(service.amount.slice(0, service.amount.length - 3))}
									estDeliveryTime={service.serviceText}
									active={values.deliveryService === service.serviceHeader}>
									<StyledDescription>{service.serviceText}</StyledDescription>
								</FormikRadioTile>
							</StyledService>
						</div>
					))}
			</FormikFieldWrapper>
		</div>
	);
};

export default Services;
